export default __webpack_public_path__ + "static/home_page_estimates-fda494eed4c014679c80cdff3177cb49.mp4";